/**
 * Centralized business / brand configuration for EMD Cleaning Service.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "EMD Cleaning Service",
  shortName: "EMD Cleaning",
  legalName: "EMD Cleaning Service",
  owner: "Diana Jaimes",
  tagline: "Professional Cleaning Services in Ontario & the Inland Empire",
  description:
    "Trusted cleaning company in Ontario, CA serving homes, offices, and commercial spaces across the Inland Empire. Deep cleaning, regular cleaning, maintenance cleaning, post-construction cleaning, specific area cleaning, and junk removal — Monday through Saturday.",

  domain: "emd-cleaning-service.com",
  url: "https://emd-cleaning-service.com",

  phone: "(909) 443-9863",
  phoneHref: "tel:+19094439863",

  email: "emdlimpieza@gmail.com",
  emailHref: "mailto:emdlimpieza@gmail.com",

  address: {
    street: "500 East E Street",
    city: "Ontario",
    state: "CA",
    postalCode: "91764",
    region: "San Bernardino County",
    serviceRadius: "30 miles",
  },

  hours: {
    summary: "Mon–Sat · 8 AM – 6 PM",
    days: "Monday – Saturday",
    time: "8:00 AM – 6:00 PM",
    closed: "Sunday",
  },

  logo: "/emd-cleaning-service-logo.png",
  // Kept as the flat JPEG: several social platforms composite transparent
  // PNGs onto black, which would wreck a yellow-on-transparent mark.
  ogImage: "/emd-cleaning-service-logo.jpeg",
  favicon: "/emd-cleaning-service-logo.png",

  social: {
    instagram: "https://www.instagram.com/emdcleaningservice",
    facebook: "https://www.facebook.com/profile.php?id=100083903330502",
    tiktok: null,
  },

  discount: {
    label: "20% Off for Returning Customers",
    short: "20% Returning Customer Discount",
    description:
      "Past clients save 20% on their next cleaning. Refer a friend and they save too — our way of saying thank you for trusting EMD Cleaning Service.",
  },

  /** EMD Cleaning Service's own LeadConnector / ReputationHub widgets. */
  widgets: {
    chatWidgetId: "6a5ec33739fddaebc9ebdfad",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/6udZ7nQv2OVl4lZASu12?widgetId=6a610d646d3785936f414284",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/63AkkhmC04MC8WRQrok6",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "63AkkhmC04MC8WRQrok6",
    formName: "Website Form",
    formHeight: "668",
  },

  serviceAreas: [
    "Ontario, CA",
    "Chino, CA",
    "Chino Hills, CA",
    "Pomona, CA",
    "West Covina, CA",
    "Montclair, CA",
    "Claremont, CA",
    "Upland, CA",
    "Rancho Cucamonga, CA",
    "Fontana, CA",
    "San Bernardino, CA",
    "Jurupa Valley, CA",
    "East Valley, CA",
    "Corona, CA",
    "Riverside, CA",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
